export default __webpack_public_path__ + "static/media/youtube.30305ce9.png";